import queryActionFactory from 'common/actions/queryActionFactory';
import DataV2 from 'common/DataV2';

import type { View } from 'common/api/endpoints/view';

export type QueryParams = {
  groupURLName?: string;
};

export const {
  // query helpers
  getQueryKey,

  // action creators
  invalidateQueries: invalidateViewQueries,
  loadQuery,
  loadMore,
  reloadQuery,

  // action types
  RequestType,
  RequestMoreType,
  LoadedType,
  LoadedMoreType,
  ErrorType,
  InvalidateType,
} = queryActionFactory<View, QueryParams>('viewQueries', DataV2.queries.views);
